import React, { ReactElement, useEffect, useRef, useState } from 'react';
import './Tabs.scss';

interface TabsProps {
    activeTab: number;
    onTabChange: (...args) => any;
    items: string[]
}

const Tabs = ({ activeTab, onTabChange, items }: TabsProps): ReactElement => {
    const [active, setActive] = useState(activeTab);
    const [isCover, setIsCover] = useState(false);

    const tabBarRef = useRef(null);
    const initialOffsetTop = useRef(0);

    const onTitleClicked = (itemNumber: number): void => {
        setActive(itemNumber);
        onTabChange(itemNumber);
    };

    const onScrolled = (): void => {
        const offsetTop = tabBarRef.current.getBoundingClientRect().top;
        if (offsetTop <= 72) {
            setIsCover(true);
        } else {
            setIsCover(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', onScrolled);
        initialOffsetTop.current = tabBarRef.current.offsetTop;

        return (): void => {
            window.removeEventListener('scroll', onScrolled);
        };
    }, []);


    return (
        <div onScroll={onScrolled} ref={tabBarRef} className='series-tabs-container' style={{ borderBottom: isCover ? '1px solid black' : 'none' }}>
            {isCover && <div className='series-tabs-cover' />}

            <div className='series-tabs-wrapper'>

                {items.map((item, index) => {
                    return <span key={item} onClick={(): void => onTitleClicked(index)}
                                 className={`series-tabs-title ${active === index && 'series-tabs-title-active'}`}>{item}</span>;
                })}

            </div>
        </div>
    );
};

export default Tabs;